const actions = {
  async list(context, payload) {
    try {
      const response = await this.$api.call("permission.list", payload);
      const responseData = response.data;

      if (payload.shouldMutateStore !== false) {
        context.commit("mutationPermissions", responseData);
      }

      return response;
    } catch (error) {
      context.commit("mutationPermissions", []);
      throw error;
    }
  },

  async detail(context, payload) {
    try {
      const response = await this.$api.call("permission.detail", payload);
      const responseData = response.data;

      if (payload.shouldMutateStore !== false) {
        context.commit("mutationPermission", responseData);
      }

      return response;
    } catch (error) {
      context.commit("mutationPermission", {});
      throw error;
    }
  },
};

export default actions;
